import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="landing-header">
      <div className="header__left">
        <a href="/" className="header__home-link">
          <span className="header__logo"><span className="header__logo-bidder">Bidder</span> iQ</span>
        </a>
      </div>
      <nav className="header__nav">
        <a href="/#why" className="header__link">Why Bidder iQ?</a>
        <a href="/#how" className="header__link">How It Works</a>
        <a href="/#pricing" className="header__link">Pricing</a>
        <a href="/#faqs" className="header__link">FAQs</a>
      </nav>
      <div className="header__right">
        <a href="/sign-up" className="header__cta">Get Started Today</a>
      </div>
    </header>
  );
}

export default Header;
